module.exports = __webpack_public_path__ + "img/diamond.b4b2ccc0.svg";